<template>
	<div class="template file">
		<div class="panel_wrap upfile-file-part">
			<div class="file-wrap-title">{{dataVal.Property.Title[0].Text}}<span v-show="dataVal.Property.Require==1" class="require">*</span>
			</div>
			<!-- <label class="panel_title">{{dataVal.title}}<span v-show="dataVal.require" class="require">*</span> </label> -->
			<div class="panel_content">
				<div class="upfile-list">
					
				</div>

				<div class="upload-file">
					<input multiple="multiple" type="file" @change="getFile($event)" class="upload-button" />
				</div>
				<div v-for="item in dataVal.fileNames" :key="item.key">{{item.key}}&nbsp;<span @click="deleteFile(item.val)"><a src="javascript:void(0)">删除</a></span></div>

			</div>
		</div>
	</div>
</template>

<script>
	
	export default {
		props: ['dataVal'],
		data() {
			return {

			}
		},
		mounted() {

		},
		methods: {

			getFile(event) {
				let that = this;
				that.dataVal.Values = [];
				// 上传文件
				let file = event.target.files
				if(file==null||file.length==0){
					that.$message.info('取消上传文件...');
					return;
				}
				that.$message.info('文件上传中...');
				let formData = new FormData()
				formData.append('category', 'settingPic')
				for(var j = 0;j<file.length;j++){
					formData.append('file', file[j]);
				}
				var strs = event.currentTarget.value.split("\\");
				// 文件上传
				that.$http({
					method: "POST",
					url: that.$httpUrl.GetAccessToken,
					data: formData
				}).then((res) => {
					let data = res.data
					if (data.ErrCode == 0) {
						that.$message.info('上传成功!');
						var fileNames = [];
						for(var i = 0 ; i < data.Body.length; i ++){
							fileNames.push({"key":data.Body[i].fileName,"val":data.Body[i].MediaId});
							that.dataVal.Values.push([data.Body[i].MediaId]);
						}
						this.$set(that.dataVal, 'fileNames', fileNames);
					} else {
						that.$message.error(data.message || '操作失败');
					}
					// this.uploadLoading = false
				}).catch((e) => {
					// this.uploadLoading = false
					console.log(e)
				})
			},
			deleteFile(val){
				var fileNames = this.dataVal.fileNames;
				var Values = this.dataVal.Values;
				for(var i = 0; i < fileNames.length; i++){
					if(fileNames[i].val == val){
						fileNames.splice(i,1);
						break;
					}
				}
				for(var j = 0; j < Values.length;j++){
					if(Values[i][0] == val){
						Values.splice(i,1);
						break;
					}
				}
			}
		}
	}
</script>

<style>
	@import '../../assets/css/common.css';
</style>
